import axios from 'axios';

import type { ProductSupplier } from '../product-suppliers-types';

export const getProductSuppliers = (productId: number): Promise<ProductSupplier[]> =>
  axios.get(`/product/${productId}/supplier`).then((response) => response.data ?? []);
